// // src/components/AboutSection.js
// import { useState } from 'react';
// import {
//   FaStar,
//   FaBed,
//   FaUtensils,
//   FaHotTub,
//   FaGlassCheers,
//   FaMosque,
//   FaHome,
//   FaEye,
//   FaShoppingBag,
//   FaArrowRight,
// } from 'react-icons/fa';
// import { motion } from 'framer-motion';
// import { useInView } from 'react-intersection-observer';
// import { Link } from 'react-router-dom';

// const AboutSection = () => {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   const [imageErrors, setImageErrors] = useState({});

//   // Category images with details
//   const categoryImages = [
//     {
//       id: 1,
//       url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/1_bed_faisal_mosque_k6yimp.jpg",
//       name: "1 Bed Faisal Mosque",
//       icon: <FaMosque />,
//       view: "Mosque View"
//     },
//     {
//       id: 2,
//       url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/2_bed_Study_Apartmant_cahvu3.jpg",
//       name: "2 Bed Study",
//       icon: <FaEye />,
//       view: "Study Room"
//     },
//     {
//       id: 3,
//       url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/studio_apartment_kzl6ch.jpg",
//       name: "Studio Apartment",
//       icon: <FaHome />,
//       view: "City View"
//     },
//     {
//       id: 4,
//       url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/2_bed_faisal_mosque_view_vr3x6n.jpg",
//       name: "2 Bed Faisal Mosque",
//       icon: <FaMosque />,
//       view: "Mosque View"
//     },
//     {
//       id: 5,
//       url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/1_bed_study_apartment_cross_view_lc95nv.jpg",
//       name: "1 Bed Study Cross",
//       icon: <FaEye />,
//       view: "Cross View"
//     },
//     {
//       id: 6,
//       url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/3_bed_faisal_mosque_pok1mw.jpg",
//       name: "3 Bed Faisal Mosque",
//       icon: <FaMosque />,
//       view: "Mosque View"
//     }
//   ];

//   // Features list from new content
//   const features = [
//     { icon: <FaBed />, text: "10+ Premium Luxury Apartments" },
//     { icon: <FaStar />, text: "5-Star Comfort & Service Standards" },
//     { icon: <FaUtensils />, text: "Complimentary Breakfast" },
//     { icon: <FaHotTub />, text: "Private Whirlpool Jacuzzi (Selected Apartments)" },
//     { icon: <FaGlassCheers />, text: "In-Room Wet Bar & Refrigerator" },
//     { icon: <FaShoppingBag />, text: "Direct Access to Dining, Shopping & Entertainment" },
//   ];

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 30, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.5, ease: "easeOut" }
//     },
//   };

//   const handleImageError = (id) => {
//     setImageErrors(prev => ({ ...prev, [id]: true }));
//   };

//   return (
//     <section className="py-12 relative overflow-hidden">
//       {/* Background Pattern
//       <div className="absolute inset-0 opacity-5">
//         <div className="absolute top-0 right-0 w-96 h-96 bg-[#c9a86c] rounded-full blur-3xl"></div>
//         <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#1a2b3c] rounded-full blur-3xl"></div>
//       </div> */}

//       <div className="container-custom relative z-10">
//         <motion.div
//           ref={ref}
//           variants={containerVariants}
//           initial="hidden"
//           animate={inView ? "visible" : "hidden"}
//           className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-start"
//         >
//           {/* Left Content - Text */}
//           <motion.div variants={itemVariants} className="space-y-4">
//             {/* ABOUT US Label */}
//             <div className="flex items-center gap-3">
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//              ABOUT US
//             </span>
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//           </div>
            

           
//             {/* Main Heading */}
            
//             <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight">
//               Experience Refined{' '}
//               <span className="font-bold text-[#c9a86c]">Luxury</span>
//               <br />
//             </h2>

//             {/* Description Paragraph 1 */}
//             <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
//               Welcome to <span className="font-semibold text-[#1a2b3c]">StayIN Centaurus Hotel Serviced Apartments</span>, where elegance, comfort, and privacy come together inside The Centaurus Mall. Since 2024, we have been delivering a premium living experience designed for business travelers, families, and long-stay guests seeking sophistication and convenience.
//             </p>

//             {/* Description Paragraph 2 */}
//             <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
//               Our fully furnished luxury apartments offer breathtaking views of <span className="font-semibold text-[#1a2b3c]">Faisal Mosque</span> and the serene <span className="font-semibold text-[#1a2b3c]">Margalla Hills</span>, paired with modern interiors and personalized hospitality.
//             </p>
//             {/* Features List with Icons */}
            

//             {/* Closing Statement */}
//             <p className="md:text-[17px] 2xl:text-lg text-gray-600 animate-fade-in-up animation-delay-400 italic pt-4 border-l-4 border-[#c9a86c] pl-4">
//               At StayIN, we don't just offer accommodation — we create an elevated lifestyle experience in Islamabad's most iconic destination.
//             </p>

//             {/* Two Buttons */}
//             <div className="flex flex-wrap gap-4 pt-6">
//               <Link
//                 to="/aboutus"
//                 className="group bg-[#c9a86c] text-white px-6 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition text-md inline-flex items-center justify-center gap-2"
//               >
//                 <span>View More About Us</span>
//                 <FaArrowRight className="group-hover:translate-x-1 transition-transform" size={12} />
//               </Link>
//             </div>
//           </motion.div>

//           {/* Right Content - Category Images Grid */}
//           <motion.div variants={itemVariants} className="sticky top-0">
//            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                {features.map((feature, index) => (
//                 <div
//                   key={index}
                  
//                   className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
//                 >
//                   <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
//                     <span className="text-[#c9a86c] text-xl group-hover:text-white transition">
//                       {feature.icon}
//                     </span>
//                   </div>

//                   <p className="2xl:text-lg text-gray-600">
//                     {feature.text}
//                   </p>
//                 </div>
//               ))}
//             </div>

//             {/* Decorative Element */}
//             <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#c9a86c]/10 rounded-full blur-2xl"></div>
//           </motion.div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default AboutSection;
// src/components/AboutSection.js
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  FaStar,
  FaBed,
  FaUtensils,
  FaHotTub,
  FaGlassCheers,
  FaMosque,
  FaHome,
  FaEye,
  FaShoppingBag,
  FaArrowRight,
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [imageErrors, setImageErrors] = useState({});

  // Category images with details
  const categoryImages = [
    {
      id: 1,
      url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/1_bed_faisal_mosque_k6yimp.jpg",
      name: "1 Bed Faisal Mosque",
      icon: <FaMosque />,
      view: "Mosque View",
      alt: "Luxury 1 bedroom apartment with Faisal Mosque view in Centaurus Islamabad"
    },
    {
      id: 2,
      url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/2_bed_Study_Apartmant_cahvu3.jpg",
      name: "2 Bed Study",
      icon: <FaEye />,
      view: "Study Room",
      alt: "2 bedroom executive apartment with study in Centaurus Islamabad"
    },
    {
      id: 3,
      url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/studio_apartment_kzl6ch.jpg",
      name: "Studio Apartment",
      icon: <FaHome />,
      view: "City View",
      alt: "Modern studio apartment in Centaurus Islamabad"
    },
    {
      id: 4,
      url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/2_bed_faisal_mosque_view_vr3x6n.jpg",
      name: "2 Bed Faisal Mosque",
      icon: <FaMosque />,
      view: "Mosque View",
      alt: "Premium 2 bedroom apartment overlooking Faisal Mosque Islamabad"
    },
    {
      id: 5,
      url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/1_bed_study_apartment_cross_view_lc95nv.jpg",
      name: "1 Bed Study Cross",
      icon: <FaEye />,
      view: "Cross View",
      alt: "Elegant 1 bedroom executive suite in Centaurus Islamabad"
    },
    {
      id: 6,
      url: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/3_bed_faisal_mosque_pok1mw.jpg",
      name: "3 Bed Faisal Mosque",
      icon: <FaMosque />,
      view: "Mosque View",
      alt: "Luxurious 3 bedroom presidential suite with Faisal Mosque view"
    }
  ];

  // Features list from new content
  const features = [
    { icon: <FaBed />, text: "10+ Premium Luxury Apartments" },
    { icon: <FaStar />, text: "5-Star Comfort & Service Standards" },
    { icon: <FaUtensils />, text: "Complimentary Breakfast" },
    { icon: <FaHotTub />, text: "Private Whirlpool Jacuzzi (Selected Apartments)" },
    { icon: <FaGlassCheers />, text: "In-Room Wet Bar & Refrigerator" },
    { icon: <FaShoppingBag />, text: "Direct Access to Dining, Shopping & Entertainment" },
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    },
  };

  const handleImageError = (id) => {
    setImageErrors(prev => ({ ...prev, [id]: true }));
  };

  return (
    <>
      {/* Simple SEO Meta Tags */}
      <Helmet>
        <title>About StayIN | Luxury Serviced Apartments Centaurus Islamabad</title>
        <meta name="description" content="Discover StayIN - premier luxury serviced apartments in Centaurus Islamabad. Experience 5-star comfort with stunning Faisal Mosque views since 2024." />
        <meta name="keywords" content="about StayIN, serviced apartments Islamabad, luxury apartments Centaurus, StayIN Centaurus" />
      </Helmet>

      <section className="py-12 relative overflow-hidden">
        <div className="container-custom relative z-10">
          <motion.div
            ref={ref}
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-start"
          >
            {/* Left Content - Text */}
            <motion.div variants={itemVariants} className="space-y-4">
              {/* ABOUT US Label */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
                <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                  ABOUT US
                </span>
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              </div>

              {/* Main Heading - Enhanced with H2 for SEO */}
              <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight">
                Experience Refined{' '}
                <span className="font-bold text-[#c9a86c]">Luxury</span>
                <br />
              </h2>

              {/* Description Paragraph 1 */}
              <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
                Welcome to <span className="font-semibold text-[#1a2b3c]">StayIN Centaurus Hotel Serviced Apartments</span>, where elegance, comfort, and privacy come together inside The Centaurus Mall. Since 2024, we have been delivering a premium living experience designed for business travelers, families, and long-stay guests seeking sophistication and convenience.
              </p>

              {/* Description Paragraph 2 */}
              <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
                Our fully furnished luxury apartments offer breathtaking views of <span className="font-semibold text-[#1a2b3c]">Faisal Mosque</span> and the serene <span className="font-semibold text-[#1a2b3c]">Margalla Hills</span>, paired with modern interiors and personalized hospitality.
              </p>

              {/* Features List - Keep original layout */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {features.slice(0, 4).map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="text-[#c9a86c] text-sm">{feature.icon}</div>
                    <p className="text-gray-600 text-sm">{feature.text}</p>
                  </div>
                ))}
              </div>

              {/* Closing Statement */}
              <p className="md:text-[17px] 2xl:text-lg text-gray-600 animate-fade-in-up animation-delay-400 italic pt-4 border-l-4 border-[#c9a86c] pl-4">
                At StayIN, we don't just offer accommodation — we create an elevated lifestyle experience in Islamabad's most iconic destination.
              </p>

              {/* Buttons */}
              <div className="flex flex-wrap gap-4 pt-6">
                <Link
                  to="/about-us"
                  className="group bg-[#c9a86c] text-white px-6 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition text-md inline-flex items-center justify-center gap-2"
                >
                  <span>View More About Us</span>
                  <FaArrowRight className="group-hover:translate-x-1 transition-transform" size={12} />
                </Link>
              </div>
            </motion.div>

            {/* Right Content - Features Grid */}
            <motion.div variants={itemVariants} className="sticky top-0">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
                  >
                    <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
                      <span className="text-[#c9a86c] text-xl group-hover:text-white transition">
                        {feature.icon}
                      </span>
                    </div>
                    <p className="2xl:text-lg text-gray-600">
                      {feature.text}
                    </p>
                  </div>
                ))}
              </div>

              {/* Decorative Element */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#c9a86c]/10 rounded-full blur-2xl"></div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;